// extracted by mini-css-extract-plugin
module.exports = {"dialog_assistant":"dialog_assistant___3oRn8","main-title":"main-title___3Cvnq","example-list-item":"example-list-item___BzCdR","assistantImg":"assistantImg___1uBHG"};